const styles = theme => ({
    root: {
        flexGrow: 1,
        minHeight: "100vh",
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary
    },
    grow: {
        flexGrow: 1,
    },
    main: {
        // marginTop: "25px"
    },
    filters: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(0.75),
        marginBottom: theme.spacing(2)
    },
    filterBlock: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        border: `1px solid ${theme.palette.divider}`,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2)
    },
    filterSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1)
    },
    filterHeader: {
        fontWeight: 600
    },
    resultHeader: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(2)
    },
    resultTitle: {
        fontWeight: 700
    },
    resultMeta: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.75)
    },
    paginationConatiner: {
        padding: theme.spacing(2.5, 0, 0, 0),
    },
    resultCount: {
        fontWeight: 500
    },
    domainInput: {
        width: '100%',
    },
    domainSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1)
    },
    domainLabel: {
        textTransform: 'uppercase',
        letterSpacing: '0.6px',
        fontWeight: 600
    },
    domainInputs: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(90px, 1fr))',
        gap: theme.spacing(1)
    },
    mediaSwitch: {
        cursor: "pointer",
        display: "inline-flex",
        alignItems: 'center',
        marginRight: theme.spacing(1.5),
        gap: theme.spacing(0.5)
    },
    mediaSwitchIcon: {
        marginLeft: theme.spacing(0.5),
        marginRight: theme.spacing(0.5),
        fontSize: "1.2rem",
        padding: theme.spacing(0.5),
        borderRadius: theme.shape.borderRadius,
        color: theme.palette.text.secondary,
        transition: theme.transitions.create(['background-color', 'color'], {
            duration: theme.transitions.duration.short
        })
    },
    mediaSwitchIconActive: {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.action.selected
    },
    mediaSwitchText: {
        fontSize: "0.8rem",
        fontWeight: 600,
        color: theme.palette.text.secondary,
        transition: theme.transitions.create(['color'], {
            duration: theme.transitions.duration.short
        })
    },
    mediaSwitchTextActive: {
        color: theme.palette.text.primary
    }
});

export default styles;
